"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackgroundImageForOrderStatus = exports.salesOrderStatusSteps = exports.deliveryDriverIcon = exports.TRestaurantMapMarkers = exports.TOrderingLocalStorageKeys = exports.spicinessImage = exports.text = exports.TDeliveryText = exports.TOrderingText = exports.RetailCustomerUnavailableForOrderMsg = exports.TSalesOrderUnavailableMessage = exports.TPaymentErrorMessage = exports.TTheme = void 0;
const SalesOrder_1 = require("../models/SalesOrder");
const TSalesOrderType_1 = require("../types/TSalesOrderType");
// replacing the THEME env variables
var TTheme;
(function (TTheme) {
    TTheme["Zam"] = "zam";
})(TTheme = exports.TTheme || (exports.TTheme = {}));
var TPaymentErrorMessage;
(function (TPaymentErrorMessage) {
    TPaymentErrorMessage["CompleteSalesOrderError"] = "Order could not be processed. If charged, your payment will be refunded. Please wait and try again. We apologise for the inconvenience.";
    TPaymentErrorMessage["SalesOrderPaymentError"] = "An issue taking the payment has occurred.";
})(TPaymentErrorMessage = exports.TPaymentErrorMessage || (exports.TPaymentErrorMessage = {}));
var TSalesOrderUnavailableMessage;
(function (TSalesOrderUnavailableMessage) {
    TSalesOrderUnavailableMessage["StoreLocationUnavailableForOrder"] = "Store location currently not set for order. You may need to refresh the page or try in a different Web browser.";
    TSalesOrderUnavailableMessage["RetailCustomerUnavailableForOrder"] = "Retail customer not set for order. You may need to refresh the page.";
})(TSalesOrderUnavailableMessage = exports.TSalesOrderUnavailableMessage || (exports.TSalesOrderUnavailableMessage = {}));
exports.RetailCustomerUnavailableForOrderMsg = "Retail customer not set for order";
// TODO The following will be deprecated
var TOrderingText;
(function (TOrderingText) {
    TOrderingText["ProfileText"] = "ProfileText";
    TOrderingText["CompleteSalesOrderError"] = "CompleteSalesOrderError";
    TOrderingText["SalesOrderPaymentError"] = "SalesOrderPaymentError";
    TOrderingText["NotesPlaceholder"] = "NotesPlaceholder";
    TOrderingText["Delivery"] = "Delivery";
})(TOrderingText = exports.TOrderingText || (exports.TOrderingText = {}));
var TDeliveryText;
(function (TDeliveryText) {
    TDeliveryText["DriverPending"] = "DriverPending";
    TDeliveryText["DriverAssigned"] = "DriverAssigned";
    TDeliveryText["DriverCompleted"] = "DriverCompleted";
    TDeliveryText["DeliveryPartnerAssigned"] = "DeliveryPartnerAssigned";
    TDeliveryText["DriverCancelled"] = "DriverCancelled";
})(TDeliveryText = exports.TDeliveryText || (exports.TDeliveryText = {}));
exports.text = {
    zam: {
        ProfileText: "To easily manage your profile, view your past orders and get many other benefits, please download the Zambrero App.",
        CompleteSalesOrderError: TPaymentErrorMessage.CompleteSalesOrderError,
        SalesOrderPaymentError: TPaymentErrorMessage.SalesOrderPaymentError,
        NotesPlaceholder: "Please enter any details for the kitchen including special dietary or allergen information.\n\nFor delivery" +
            " orders you can also include extra instructions for your courier to" +
            " ensure a successful handover. (max length 200)",
        Delivery: {
            DriverPending: "Our delivery partner will be assigned by the restaurant.",
            DriverAssigned: "Our delivery partner has been assigned by the" +
                " restaurant and is on their way.",
            DeliveryPartnerAssigned: "Our delivery partner has been assigned by the" +
                " restaurant. A driver will be on the way shortly. {tracking_link}",
            DriverCompleted: "Our delivery partner has completed your order.",
            DriverCancelled: "Our delivery partner has sadly cancelled your order. You will receive a refund in 3-5 business days. We suggest placing another delivery order."
        }
    }
};
exports.spicinessImage = "https://dph95f73vdxmz.cloudfront.net/uploads/chilli.png";
var TOrderingLocalStorageKeys;
(function (TOrderingLocalStorageKeys) {
    TOrderingLocalStorageKeys["OrderType"] = "@ordering:orderType";
})(TOrderingLocalStorageKeys = exports.TOrderingLocalStorageKeys || (exports.TOrderingLocalStorageKeys = {}));
var TRestaurantMapMarkers;
(function (TRestaurantMapMarkers) {
    TRestaurantMapMarkers["Selected"] = "https://dph95f73vdxmz.cloudfront.net/uploads/pin-cream.png";
    TRestaurantMapMarkers["UnSelected"] = "https://dph95f73vdxmz.cloudfront.net/uploads/pin-green.png";
})(TRestaurantMapMarkers = exports.TRestaurantMapMarkers || (exports.TRestaurantMapMarkers = {}));
exports.deliveryDriverIcon = "https://zam-website-assets.s3.ap-southeast-2.amazonaws.com/uploads/dasher.png";
exports.salesOrderStatusSteps = new Map([
    [
        TSalesOrderType_1.TSalesOrderType.Pickup,
        new Map([
            [SalesOrder_1.TSalesOrderStatus.Preparing, 1],
            [SalesOrder_1.TSalesOrderStatus.Ready, 2],
            [SalesOrder_1.TSalesOrderStatus.Completed, 3]
        ])
    ],
    [
        TSalesOrderType_1.TSalesOrderType.Delivery,
        new Map([
            [SalesOrder_1.TSalesOrderStatus.Preparing, 1],
            [SalesOrder_1.TSalesOrderStatus.Ready, 2],
            [SalesOrder_1.TSalesOrderStatus.Delivering, 3],
            [SalesOrder_1.TSalesOrderStatus.Completed, 4]
        ])
    ]
]);
const getBackgroundImageForOrderStatus = (status) => {
    const { pendingOrderStatusImage, preparingOrderStatusImage, readyOrderStatusImage, deliveringOrderStatusImage, completedOrderStatusImage, baseLocationImageUrl } = env;
    switch (status) {
        case SalesOrder_1.TSalesOrderStatus.Pending:
            if (pendingOrderStatusImage) {
                return pendingOrderStatusImage;
            }
            break;
        case SalesOrder_1.TSalesOrderStatus.Preparing:
            if (pendingOrderStatusImage) {
                return preparingOrderStatusImage;
            }
            break;
        case SalesOrder_1.TSalesOrderStatus.Ready:
            if (pendingOrderStatusImage) {
                return readyOrderStatusImage;
            }
            break;
        case SalesOrder_1.TSalesOrderStatus.Delivering:
            if (pendingOrderStatusImage) {
                return deliveringOrderStatusImage;
            }
            break;
        case SalesOrder_1.TSalesOrderStatus.Completed:
            if (pendingOrderStatusImage) {
                return completedOrderStatusImage;
            }
            break;
        default:
            return baseLocationImageUrl;
    }
};
exports.getBackgroundImageForOrderStatus = getBackgroundImageForOrderStatus;
//# sourceMappingURL=constants.js.map